import { Action } from '@ngrx/store';

export enum LoaderActionTypes {
  SHOW_LOADER = '[Loader] Show loader',
  HIDE_LOADER = '[Loader] Hide loader',
}

export class ShowLoader implements Action {
  readonly type = LoaderActionTypes.SHOW_LOADER;
  payload: { action: Action | string };

  constructor(action: Action | string) {
    this.payload = { action };
  }
}

export class HideLoader implements Action {
  readonly type = LoaderActionTypes.HIDE_LOADER;
  payload: { action: Action | string };

  constructor(action: Action | string) {
    this.payload = { action };
  }
}
